module.exports = __webpack_public_path__ + "static/media/CoverCircle (1).7019c70c.png";